import { format, setDate, setMonth, subYears } from "date-fns";

/**
 * Calculates percentage change between two values
 * @param firstCycle - Current period value
 * @param secondCycle - Previous period value
 * @returns Percentage change (0 if secondCycle is 0 to avoid division by zero)
 */
export function calculatePercentageChange(
  firstCycle: number,
  secondCycle: number,
): number {
  if (secondCycle === 0) {
    return 0;
  }
  return ((firstCycle - secondCycle) / secondCycle) * 100;
}

/**
 * Date period utilities for statistics calculations
 * All periods are calculated from August 1st to current date
 */
export const statisticsPeriods = {
  current: {
    start: format(setDate(setMonth(new Date(), 7), 1), "yyyy-MM-dd"),
    end: format(new Date(), "yyyy-MM-dd"),
  },
  lastYear: {
    start: format(
      setDate(setMonth(subYears(new Date(), 1), 7), 1),
      "yyyy-MM-dd",
    ),
    end: format(subYears(new Date(), 1), "yyyy-MM-dd"),
  },
} as const;
